import { writable } from 'svelte/store';
import { generateRequestId } from 'src/services/api/common/ws/WebSocketApi';
export function createWebSocketObservable({ api, responsePredicate, getResponseValue, }) {
    const state = {
        value: void 0,
        hasValue: false,
        loading: false,
        error: null,
    };
    return writable(state, set => {
        return api.subscribe({
            responsePredicate,
        }, (response, error) => {
            state.loading = false;
            try {
                if (error) {
                    state.error = error;
                    set(state);
                    return;
                }
                state.value = getResponseValue(response);
                state.hasValue = true;
                set(state);
            }
            catch (err) {
                console.error(err);
            }
        });
    });
}
export function createWebSocketSend({ api, createRequest, }) {
    return function send({ data, requestId, } = {}) {
        return api.send({
            data: createRequest(data),
            requestId,
        }, (err) => {
            console.error(err);
        });
    };
}
export function createWebSocketRequest({ api, createRequest, getResponseValue, }) {
    return function request({ data, abortSignal, timeout, requestId, } = {}) {
        return api.request({
            data: createRequest(data),
            abortSignal,
            timeout,
            requestId,
        })
            .then(getResponseValue);
    };
}
export function createWebSocketStore({ api, createRequest, responsePredicate, getResponseValue, }) {
    const observable = createWebSocketObservable({
        api,
        getResponseValue,
        responsePredicate(responseData, responseRequestId) {
            return responsePredicate(responseData, responseRequestId);
        },
    });
    const send = createWebSocketSend({
        api,
        createRequest,
    });
    const request = createWebSocketRequest({
        api,
        createRequest,
        getResponseValue,
    });
    function onStartLoading() {
        observable.update(o => {
            o.loading = true;
            return o;
        });
    }
    return {
        subscribe() {
            return observable.subscribe.apply(observable, arguments);
        },
        reset() {
            observable.update(o => {
                o.hasValue = false;
                o.value = void 0;
                o.error = null;
                return o;
            });
        },
        send(args) {
            send(Object.assign({}, args));
            onStartLoading();
        },
        request(args) {
            const requestId = generateRequestId();
            const result = request(Object.assign(Object.assign({}, args), { requestId }));
            onStartLoading();
            return result;
        },
    };
}
